var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIconB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0886 25.5823C19.9886 25.5823 25.5823 19.9887 25.5823 13.0886C25.5823 6.18854 19.9886 0.594937 13.0886 0.594937C6.18852 0.594937 0.59491 6.18854 0.59491 13.0886C0.59491 19.9887 6.18852 25.5823 13.0886 25.5823Z",
    stroke: "#0C4B76",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8708 20.8228H10.969V13.9802H9.51898V11.6224H10.969V10.2069C10.969 8.28357 11.7873 7.13924 14.1137 7.13924H16.05V9.49785H14.8398C13.9342 9.49785 13.8743 9.82733 13.8743 10.4422L13.8703 11.6224H16.0633L15.8066 13.9802H13.8703V20.8228H13.8708Z",
    fill: "#0C4B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIconB);
export default __webpack_public_path__ + "static/media/fb-icon-b.73ce49e3773e2d474424dc8e12928261.svg";
export { ForwardRef as ReactComponent };